import styled from "styled-components";

export const PageContainer = styled.div`
  background-color: white;
  padding: 0 0 2rem 0;
`;

export const ContainerItems = styled.div`
  padding: 0 1rem;
`;

export const Title = styled.div`
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1.5rem 0;
  color: #808080;


  img {
    width: 4%;
  }

  span {
    margin-left: 1rem;
  }

`;

export const StatusOrder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0 1rem 0;

  h4 {
    font-size: 1.2rem;
    color: #000FFF;
    margin-bottom: 1.4rem;
  }
`;

export const ContentStatus = styled.div`
  display: flex;
`;

export const StatusCollor = styled.div`
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 2rem;
  margin: 0.2rem 0.3rem 0 0;
  background-color: ${(props) => {
    if (
      props.status === "AGUARDANDO ANÁLISE DO FINANCEIRO" ||
      props.status === "EM ANÁLISE PELO FINANCEIRO" ||
      props.status ===
        "AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO" ||
      props.status ===
        "AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO"
    ) {
      return `#000FFF`;
    } else if (props.status === "LIBERADO") {
      return `#00E309`;
    } else if (props.status === "NÃO LIBERADO PELO FINANCEIRO") {
      return `#F7D100`;
    } else {
      return `#FD0000`;
    }
  }};
`;

export const Status = styled.div`
  margin-bottom: 0.2rem;
  margin-top: -0.3rem;
  color: #000FFF;
  font-weight: 550;

  @media (max-width: 768px) {
    margin-bottom: 0rem;
    margin-top: 0rem;
    margin: 0 .5rem 0 0;
  }

`;

export const ItemDetails = styled.div`
  color: #808080;
  font-size: 11px;
  font-weight: 300;
  margin: ${(props) => props.margin};
  display: flex;
  justify-content: flex-end;

  @media (max-width: 500px) {
    font-size: 10px;
    margin: ${(props) => props.margin500};
  }

  @media (min-width: 768px) {
    ${Status} {
      margin-top: 0rem;
      margin-left: 1.5rem;
      margin-right: 0.5rem;
    }
  }
`;

export const ButtonEdit = styled.div`
  margin: 0 1rem;

  button {
    outline: ${(props) => props.children.props.disable ?
    "none" : "black"};
    width: 100%;
    padding: .5rem 1rem;
    color: white;
    border: 0;
    border-radius: 5px;
    background: ${(props) => props.children.props.disable ?
    "#c2c2c2 0% 0% no-repeat padding-box" :
    "#000FFF 0% 0% no-repeat padding-box"};
    box-shadow: 0px 2px 4px #00000033;
    cursor: ${(props) => props.children.props.disable ?
    "default" : "pointer"};
  }
`;

export const LoadingIcon = styled.i`
  font-size: 15px;
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  cursor: pointer;
`;
